import { Component, effect, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { TableColumn, TableColumnType } from '../../../../../modules/shared/components/kit/table/table.types';
import { dateField } from '../../../../../modules/shared/components/kit/table/table.fields';
import { ActionButtonsComponent } from '../../../../kit/action-buttons/action-buttons.component';
import { FolderSickNotesAssumeSickNoteModalStore } from './folder-sick-notes-assume-sick-note-modal.store';
import { CsszSickNoteStateEnum } from '@libs/types/src/services/enum/cssz/cssz-sick-note-state.enum';
import { folderOtherSickNoteListFrag } from '../../../../../services/types/folder-sick-notes.types';
import { SickNoteShortObject } from '@libs/types/src/services/object-type/cssz/sick-notes.object';
import { translate } from '../../../../../modules/shared/shared.global-service';
import {
    FolderSickNotesConfirmTakeoverModalComponent,
} from '../folder-sick-notes-confirm-takeover-modal/folder-sick-notes-confirm-takeover-modal.component';
import { BaseDialogService } from '../../../../kit/base-dialog/base-dialog-service';
import { TableComponent } from '../../../../../modules/shared/components/kit/table/table.component';

@Component({
    selector: 'app-folder-sick-notes-assume-sick-note-modal',
    templateUrl: 'folder-sick-notes-assume-sick-note-modal.component.html',
    styleUrls: ['folder-sick-notes-assume-sick-note-modal.component.scss'],
    imports: [
        ActionButtonsComponent,
        TableComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [FolderSickNotesAssumeSickNoteModalStore],
})
export class FolderSickNotesAssumeSickNoteModalComponent extends BaseDialogComponent {
    public readonly store = inject(FolderSickNotesAssumeSickNoteModalStore);
    protected readonly dialogService = inject(BaseDialogService);

    protected columns: TableColumn[] = [
        dateField('issueDate', false, false),
        {
            name: 'namePzs',
        },
        {
            name: 'doctorName',
        },
        {
            name: 'decisionNumber',
        },
        {
            name: 'state',
            type: TableColumnType.Tag,
            tagOptions: {
                labelPrefix: '',
            },
            severity: (item: string) => {
                return item === CsszSickNoteStateEnum.OTV || item === CsszSickNoteStateEnum.RZP
                    ? 'success'
                    : item === CsszSickNoteStateEnum.UKC
                        ? 'secondary'
                        : 'danger';
            },
            filterable: false,
        },
    ];

    protected selectedItem = signal<SickNoteShortObject | null>(null);

    constructor() {
        super();
        effect(() => {
            if (this.store.folder() && this.store.folder()!.person.insuranceNumber) {
                this.store.api.getOtherSickNotes({
                    insuranceNumber: this.store.folder()!.person.insuranceNumber!,
                    serviceId: this.store.folder()!.serviceId,
                }, folderOtherSickNoteListFrag).then();
            }
        });
    }


    protected confirmModal() {
        const ref = this.dialogService.open(FolderSickNotesConfirmTakeoverModalComponent, {
            header: translate.instant('sickNotes.confirmTakeOver.title'),
            styleClass: 'p-dialog-width-50',
            data: {
                selectedItem: this.selectedItem(),
            },
        });
        ref.onClose.subscribe((result) => {
            if (result) {
                this.dialogRef.close(result);
            }
        });
    }

    selection(event: any) {
        this.selectedItem.set(event);
    }

}
